// extracted by mini-css-extract-plugin
export default {"container":"style_container__8aKUC","header":"style_header__PqhYo","status":"style_status__py3YQ","message":"style_message__ChhZ-"};